import React from "react";
import BForm from "../../components/forms/BForm";

export default function NotesForm({
  onSubmit,
  btnText,
  preloadedData,
  success,
  responseErrors,
}) {
  const fields = [
    {
      fieldName: "note",
      placeholder: "Notieren",
      type: "textarea",
      cols: 40,
      rows: 10,
    },
  ];

  return (
    <BForm
      preloadedData={preloadedData}
      btnText={btnText}
      submit={onSubmit}
      fields={fields}
      success={success}
      responseErrors={responseErrors}
    />
  );
}
